import { Component, Input } from '@angular/core';
import { AlarmMonitoring } from 'ops/common/models/alarm-monitoring';

@Component({
    selector: 'app-alarm-monitoring-detail-overlay',
    templateUrl: './alarm-monitoring-detail-overlay.component.html',
    styleUrls: ['./alarm-monitoring-detail-overlay.component.css'],
    standalone: false
})
export class AlarmMonitoringDetailOverlayComponent {
    @Input() alarm: AlarmMonitoring;

    style = {
        display: 'none',
    };

    public setVisible(visible: boolean) {
        this.style.display = visible ? 'flex' : 'none';
    }
}
